import React from 'react';
import { Message, Radio } from 'ui';
import ImperialParcelDetails from '~/components/ListFlow/ShippingSection/ImperialParcelDetails';
import MetricParcelDetails from '~/components/ListFlow/ShippingSection/MetricParcelDetails';
import useKnownCookie from '~/hooks/useKnownCookie';
import {
  editParcel,
  getListFlowCustomParcel,
  getListFlowShipping,
} from '~/store/listFlow/slices/shipping';
import { useAppDispatch, useAppSelector } from '~/store/store';

interface Props {}

const ListFlowCustomParcelDetails: React.FC<Props> = () => {
  const [unit, setUnit] = useKnownCookie('sls_lfunit');
  const dispatch = useAppDispatch();
  const customParcel = useAppSelector(getListFlowCustomParcel);
  const shipping = useAppSelector(getListFlowShipping);

  const isImperial = !unit || unit === 'imperial';

  return (
    <div className="mt-4">
      {shipping.showShippingDiscountNowInvalidWarning && (
        <Message warning>
          Reminder: You can&apos;t offer shipping discounts with custom
          dimensions.
        </Message>
      )}

      <div className="mt-4">
        {isImperial ? (
          <ImperialParcelDetails
            onChangeParcel={parcel => dispatch(editParcel({ parcel }))}
            parcel={customParcel}
          />
        ) : (
          <MetricParcelDetails
            onChangeParcel={parcel => dispatch(editParcel({ parcel }))}
            parcel={customParcel}
          />
        )}
      </div>

      <div className="flex space-x-4">
        <label>
          <Radio
            className="mr-1"
            name="unit"
            value="imperial"
            checked={isImperial}
            onChange={() => setUnit('imperial')}
          />{' '}
          Imperial
        </label>

        <label>
          <Radio
            className="mr-1"
            name="unit"
            value="metric"
            checked={!isImperial}
            onChange={() => setUnit('metric')}
          />{' '}
          Metric
        </label>
      </div>
    </div>
  );
};

export default ListFlowCustomParcelDetails;
